<template>
  <div
    id="ride-monitoring"
    class="page-content ride-monitoring"
  >
    <ride-monitoring-column
      v-for="index in columnIndex.list"
      :key="index"
      :column-index="index"
      @remove-column="removeColumn"
    />

    <div>
      <p-button
        class="btn-add-column"
        type="info"
        round
        @click="addNewColumn"
      >
        +
      </p-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, reactive, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const RideMonitoringColumn = defineAsyncComponent(() => import('./RideMonitoring/RideMonitoringColumn.vue') as any);

const route = useRoute();
const columnIndex: {
  list: number[];
  current: number;
} = reactive({
  list: [0, 1],
  current: 2,
});

const addNewColumn = () => {
  columnIndex.list.push(columnIndex.current);
  columnIndex.current++;
};

const removeColumn = (index: number) => {
  columnIndex.list = columnIndex.list.filter((idx) => idx !== index);
};

onMounted(async () => {
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>

<style lang="scss">
.ride-monitoring {
  display: flex;
  overflow: auto;
  overflow-y: hidden;

  .btn-add-column {
    min-width: unset;
    width: 50px !important;
    height: 50px;
    font-size: 40px !important;
    padding: 0 !important;
    line-height: 40px;
  }
}
</style>
